module.exports = __webpack_public_path__ + "img/beefeater-form-bg.aa5eff78.jpg";